var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    [
      _c(
        "w-col",
        { attrs: { xs: "12" } },
        [
          _c("w-checkbox", {
            attrs: { label: _vm.$ct("hide-detail-rows") },
            model: {
              value: _vm.value.HideDetailRows,
              callback: function ($$v) {
                _vm.$set(_vm.value, "HideDetailRows", $$v)
              },
              expression: "value.HideDetailRows",
            },
          }),
          _c(
            "w-sortable",
            {
              attrs: {
                tag: "w-list",
                items: _vm.value.Columns,
                "target-class": "handle",
              },
            },
            _vm._l(_vm.value.Columns, function (col, i) {
              return _c(
                "w-list-item",
                { key: i, attrs: { "show-handle": "" } },
                [
                  _c("w-list-item-text", [_vm._v(_vm._s(col.Name))]),
                  _c(
                    "w-list-item-action",
                    [
                      _c(
                        "w-button",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: _vm.$ct("common.edit"),
                              expression: "$ct('common.edit')",
                            },
                          ],
                          on: {
                            click: function ($event) {
                              return _vm.editCol(i)
                            },
                          },
                        },
                        [_c("w-fa", { attrs: { icon: "pen" } })],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "w-list-item-action",
                    [
                      _c(
                        "w-button",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: _vm.$ct("common.edit-style"),
                              expression: "$ct('common.edit-style')",
                            },
                          ],
                          on: {
                            click: function ($event) {
                              return _vm.editStyle(i)
                            },
                          },
                        },
                        [_c("w-fa", { attrs: { icon: "font" } })],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "w-list-item-action",
                    [
                      _c(
                        "w-button",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: _vm.$ct("common.delete"),
                              expression: "$ct('common.delete')",
                            },
                          ],
                          staticClass: "danger",
                          on: {
                            click: function ($event) {
                              return _vm.removeCol(i)
                            },
                          },
                        },
                        [_c("w-fa", { attrs: { icon: "trash" } })],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            }),
            1
          ),
          _c(
            "w-list",
            [
              _vm.value.Columns.length == 0
                ? _c(
                    "w-list-item",
                    [
                      _c("w-list-item-text", [
                        _vm._v(" " + _vm._s(_vm.$ct("no-columns")) + " "),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "w-list-item",
                {
                  on: {
                    click: function ($event) {
                      return _vm.addColumn()
                    },
                  },
                },
                [
                  _c(
                    "w-list-item-icon",
                    [_c("w-fa", { attrs: { icon: "plus" } })],
                    1
                  ),
                  _c("w-list-item-text", [
                    _vm._v(" " + _vm._s(_vm.$ct("common.add")) + " "),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-modal",
        { attrs: { value: _vm.toEditColumn != null } },
        [
          _vm.toEditColumn != null
            ? _c("app-select-columns", {
                attrs: {
                  value: _vm.toEditColumn,
                  model: _vm.model,
                  browse: _vm.browse,
                },
                on: {
                  cancel: function ($event) {
                    _vm.toEditColumn = null
                  },
                  confirm: function ($event) {
                    return _vm.confirmEdit()
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "w-modal",
        { attrs: { value: _vm.toEditStyle != null } },
        [
          _vm.toEditStyle != null
            ? _c("app-style-editor", {
                attrs: { value: _vm.toEditStyle },
                on: {
                  close: function ($event) {
                    _vm.toEditStyle = null
                  },
                  input: function ($event) {
                    return _vm.confirmEditStyle($event)
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }